import BulkMailBuilder from '../BulkMail/bulk-mail-builder';
import { AppSettings } from '../constants';
import ManageMediaLibraries from './Containers/manage-media-libraries';

export default [
  {
    path: '/bulk-mail',
    component: BulkMailBuilder,
    private: true,
    portal: ['Builder'],
    menu: {
      name:
        AppSettings.clientTypeValue === 'Builder'
          ? 'Project Buzz'
          : 'Bulk mail',
      order: 15,
      iconClass: 'pe-7s-mail',
    },
  },
  {
    path: '/media-libraries',
    component: ManageMediaLibraries,
    private: true,
    portal: ['Builder'],
    menu: {
      name: 'Media Library',
      order: 15,
      iconClass: 'pe-7s-video',
    },
  },
];



// WEBPACK FOOTER //
// ./src/MediaLibrary/routes.js